export const products = [
  {
    id: 1,
    name: "Edwards EST3 Panel",
    image: require('../assets/products/edwards_panel.jpg'),
    link: ""
  },
  {
    id: 2,
    name: "Huawei OLT EA5800_X7",
    image: require('../assets/products/EA5800.png'),
    link: "/allproducts/"
  },
  {
    id: 3,
    name: "Honeywell IFP-75 Panel",
    image: require('../assets/products/IFP-75_RED.png'),
    link: ""
  },
  {
    id: 4,
    name: "NightOwl Series 6KW",
    image: require('../assets/products/night_owl.webp'),
    link: "/"
  },
  {
    id: 5,
    name: "HD3200 Amplifier",
    image: require('../assets/products/HD3200_amplifier.jpg'),
    link: ""
  },
  {
    id: 6,
    name: "Honeywell MAXPRO NVR 128CH",
    image: require('../assets/products/max_pro_nvr.png'),
    link: ""
  }
];
